<template>
  <div v-loading="VDDLoading">
    <div id="VDDBox"   style="width: 100%; min-height: 700px">
  
    </div>
  </div>
</template>

<script>
import indexJs from "./index";
export default {
    mixins: [indexJs]
}
</script>

<style>

</style>